<template>
  <div style="position:relative; margin-top: -2rem;">
    <div
      class="scrollContainer"
      style="overflow: hidden; scroll-behavior: smooth; margin: 0px 3rem;"
    >
      <div class="d-flex">
        <book-thumbnail
          :imgCover="bookItem.imgCover"
          :bookTitle="bookItem.bookTitle"
          :bookDesc="bookItem.bookDesc"
          :bookId="bookItem.bookId"
          :size="bookItem.size"
          :bookStock="bookItem.bookStock"
          v-for="bookItem in items"
          :key="bookItem.id"
          :promo="bookItem.promo"
          @selbook="$emit('selbook');"
        />
      </div>
    </div>
    <div
      class="d-flex align-items-center bg-white"
      style="position: absolute; top:0px; height: 100%; right: 0px; font-size: x-large;"
      @click="tooglePage(1)"
      v-if="pageRight"
    >
      <div class="p-2 slide-button">
        <b-icon icon="chevron-right" />
      </div>
    </div>
    <div
      class="d-flex align-items-center bg-white"
      style="position: absolute; top:0px; height: 100%; left: 0px; font-size: x-large;"
      @click="tooglePage(-1)"
      v-if="pageLeft"
    >
      <div class="p-2 slide-button">
        <b-icon icon="chevron-left" />
      </div>
    </div>
    <book-modal :bookData="bookModalData" :modalid="_uid" />
  </div>
</template>
<script>
import BookThumbnail from "@/components/BookThumbnail.vue";
import BookModal from "@/components/BookModal.vue";

export default {
  components: {
    BookThumbnail,
    BookModal
  },
  props: {
    items: Array
  },
  data() {
    return {
      pageLeft: false,
      pageRight: true,
      bookModalData: {}
    };
  },
  methods: {
    tooglePage: function(direction) {
      console.log(this.$children[0].$el);
      
      this.$el.querySelector(".scrollContainer").scrollLeft +=
        direction * this.$el.querySelector('.book-thumbnail').getBoundingClientRect().width;

      const nextPos =
        this.$el.querySelector(".scrollContainer").scrollLeft +
        direction * this.$el.querySelector('.book-thumbnail').getBoundingClientRect().width;

      if (nextPos <= 0) {
        this.pageLeft = false;
      } else {
        this.pageLeft = true;
      }
      if (
        nextPos >=
        this.$el.querySelector(".scrollContainer").scrollWidth -
          this.$el.querySelector(".scrollContainer").offsetWidth
      ) {
        this.pageRight = false;
      } else {
        this.pageRight = true;
      }
    },
    showModal: function(itemId) {
      let modalData = {};
      this.items.forEach(function(element) {
        if (element.bookId === itemId) {
          modalData = element;
        }
      });
      this.bookModalData = modalData;
      this.$bvModal.show("bookModal_" + this._uid);
    }
  }
};
</script>
